'use es6';

import { THEME, DESIGN_ROOT } from 'DesignData/enums/FolderSubcategories';
import { QUERY_STRING_THEME_FOLDER } from 'DesignData/constants/Routing';
/**
 * @param {DesignData/models/folders/FolderNode} folder
 */

export const isThemeRootFolder = folder => !!folder && folder.subcategory === THEME;
/**
 * If assetId either is or is in a theme folder,
 * the theme folderId is returned.
 */

export function getAssetParentThemeFolderId(files, folders, assetId) {
  if (!assetId) return null;
  const asset = files[assetId] || folders[assetId];
  if (!asset) return null;
  if (isThemeRootFolder(asset)) return assetId;
  if (asset.subcategory === DESIGN_ROOT) return null;
  const parentFolderId = asset.parentFolderId || asset.folderId;
  if (!parentFolderId) return null;
  return getAssetParentThemeFolderId(files, folders, parentFolderId);
}
export const getThemeFolderIdFromUrlQueryString = () => {
  const tfid = window.location.search.split(`${QUERY_STRING_THEME_FOLDER}=`)[1];
  return tfid ? parseInt(tfid, 10) : null;
};
export const getThemeFolderIdFromUrlSearchString = search => {
  const tfid = search.split(`${QUERY_STRING_THEME_FOLDER}=`)[1];
  return tfid ? parseInt(tfid, 10) : null;
};